var h = Object.defineProperty;
var n = (r, e, o) => e in r ? h(r, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : r[e] = o;
var t = (r, e, o) => n(r, typeof e != "symbol" ? e + "" : e, o);
import { DocumentBuilder as i } from "./document-builder.js";
import { BlockParser as u } from "./block-parser.js";
class B {
  constructor(e) {
    t(this, "schema");
    this.schema = e;
  }
  parse(e, o) {
    let c = new i(this.schema), l = new u(c, o), s = e.blocks;
    return s.forEach((a, m) => {
      l.handle(a, s[m + 1]);
    }), c.doc;
  }
}
export {
  B as BlocksParser
};
